import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from "@angular/material/snack-bar";

@Component({
  selector: "app-alert",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./alert.component.html",
  styleUrl: "./alert.component.scss",
})
export class AlertComponent {
  message: string = "";

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<AlertComponent>,
  ) {}

  closeSnackbar() {
    this.snackBarRef.dismiss();
  }
}
